/**
 * Pneus/posições oferecidos num item de pneu do checklist ("qual pneu?"):
 * vêm do mapa do cavalo e da carreta do checklist. Sem mapa (veículo sem
 * configuração) a lista fica vazia e o item segue como antes — texto livre.
 */
import { useQueries } from "@tanstack/react-query";
import type { TireMapDto } from "@bi/types";
import { api } from "../../lib/api";

export interface RunTireOption {
  key: string;
  tireId: string | null;
  positionId: string;
  label: string;
}

export function useRunTireOptions(plates: Array<string | null | undefined>, enabled: boolean): RunTireOption[] {
  const alvo = [...new Set(plates.filter(Boolean) as string[])];
  const mapas = useQueries({
    queries: alvo.map((p) => ({
      queryKey: ["tires", "map", p],
      queryFn: () => api.get<TireMapDto>(`/fleet/vehicles/${encodeURIComponent(p)}/tire-map`),
      enabled,
      retry: false,
      staleTime: 60_000,
    })),
  });
  const out: RunTireOption[] = [];
  for (const q of mapas) {
    const m = q.data;
    if (!m?.configuration) continue;
    for (const a of m.axles) {
      for (const pos of a.positions) {
        out.push({
          key: `${m.vehicle.plate}:${pos.id}`,
          tireId: pos.tire?.id ?? null,
          positionId: pos.id,
          label: `${m.vehicle.plate} · ${pos.label} · ${pos.tire ? `pneu ${pos.tire.code}` : "vazia"}`,
        });
      }
    }
  }
  return out;
}
